import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { AppLayoutFooter } from '../_share_/AppLayoutFooter/AppLayoutFooter';
import { InternalAppLayoutHeader } from './InternalAppLayoutHeader/InternalAppLayoutHeader';

export const InternalAppLayout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen bg-[#f2f5fa] px-4">
      <InternalAppLayoutHeader />
      <Outlet />
      <AppLayoutFooter />
    </div>
  );
};
